import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { RoutingContext } from '../../../../core/model';
import { ArticleCarouselModule, PrincipalConfigurationDirectiveModule, routingContextGuard } from '../../../../shared';
import { AddToAreaOfUseModule } from '../../../../shared/components/add-to-area-of-use/add-to-area-of-use.module';
import { AddToOrderCardModule } from '../../../../shared/components/add-to-order-card/add-to-order-card.module';
import { ProductCarouselModule } from '../../../../shared/components/product-carousel';
import { CatalogBreadcrumbModule } from '../../components/catalog-breadcrumb/catalog-breadcrumb.module';
import { PdpImageGalleryModule } from '../../components/pdp-image-gallery/pdp-image-gallery.module';
import { PdpOverviewModule } from '../../components/pdp-overview/pdp-overview.module';
import { PdpSkuPickerModule } from '../../components/pdp-sku-picker/pdp-sku-picker.module';
import { PdpArticleListTabsModule } from '../../components/pdp-tabs/pdp-article-list-tabs/pdp-article-list-tabs.module';
import { PdpSkuPickerTabsModule } from '../../components/pdp-tabs/pdp-sku-picker-tabs/pdp-sku-picker-tabs.module';
import { SampleOrderModalModule } from '../../components/sample-order-modal/sample-order-modal.module';
import { PdpComponent } from './pdp.component';

@NgModule({
  declarations: [PdpComponent],
  exports: [PdpComponent],
  imports: [
    CommonModule,
    NzIconModule,
    I18nModule,
    PdpImageGalleryModule,
    PdpOverviewModule,
    CatalogBreadcrumbModule,
    PdpSkuPickerModule,
    ProductCarouselModule,
    ArticleCarouselModule,
    AddToOrderCardModule,
    PrincipalConfigurationDirectiveModule,
    AddToAreaOfUseModule,
    SampleOrderModalModule,
    PdpSkuPickerTabsModule,
    PdpArticleListTabsModule,
    RouterModule.forChild([
      {
        path: '',
        component: PdpComponent,
        canActivate: [routingContextGuard(RoutingContext.PDP)],
      },
    ]),
  ],
  providers: [],
})
export class PdpModule {}
